(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function initCountdown(el) {
    var target = el.getAttribute('data-target');
    if (!target) return;
    var targetDate = new Date(target);
    if (Number.isNaN(targetDate.getTime())) return;
    var completeText = el.getAttribute('data-complete-text') || 'The waitlist is now open.';
    function tick() {
      var diff = targetDate.getTime() - Date.now();
      if (diff <= 0) {
        el.querySelector('[data-days]').textContent = '00';
        el.querySelector('[data-hours]').textContent = '00';
        el.querySelector('[data-minutes]').textContent = '00';
        el.querySelector('[data-seconds]').textContent = '00';
        var message = el.querySelector('[data-countdown-message]');
        if (message) message.textContent = completeText;
        return;
      }
      var seconds = Math.floor(diff / 1000);
      var days = Math.floor(seconds / 86400); seconds -= days * 86400;
      var hours = Math.floor(seconds / 3600); seconds -= hours * 3600;
      var minutes = Math.floor(seconds / 60); seconds -= minutes * 60;
      el.querySelector('[data-days]').textContent = pad(days);
      el.querySelector('[data-hours]').textContent = pad(hours);
      el.querySelector('[data-minutes]').textContent = pad(minutes);
      el.querySelector('[data-seconds]').textContent = pad(seconds);
    }
    tick();
    setInterval(tick, 1000);
  }
  function initHeader(header) {
    var btn = header.querySelector('[data-tih-menu-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tih-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-tih-header]').forEach(initHeader);
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-tih-countdown]').forEach(initCountdown);
    event.target.querySelectorAll('[data-tih-header]').forEach(initHeader);
  });
})();
